import { createSlotRecipe } from './runtime.js';

const bottomSheetConfig = {"name":"bottomSheet","slots":["root","overlay","content","handle","contentInner","header","title","description","body","footer","close"],"variantMap":{"contained":["true"]}}

export const bottomSheet = /* @__PURE__ */ createSlotRecipe(bottomSheetConfig)